/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {State} from './state';
import {Stage} from './stage';
import { JsonpClientBackend } from '@angular/common/http';
import { SystemType } from './enums/system.type';
import { LinkedReportType } from './enums/linked.report.type';

export class ReportLink {
  ID: string;
  COMPANY_NAME: string;
  STATE: State;
  STAGE: Stage;
  TYPE: LinkedReportType;
  SYSTEM_TYPE: SystemType;

  //helper
  isLoading: boolean;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.STATE)
      this.STATE = State.parse(value.STATE);

    if(value.STAGE)
      this.STAGE = Stage.parse(value.STAGE);
  }

  static parse(json: any): ReportLink {
    if (json) {
      const h = new ReportLink();

      h.ID = json.ID;
      if(json.CLIENT)
        h.COMPANY_NAME = json.CLIENT.COMPANY_NAME;
      else
        h.COMPANY_NAME = json.COMPANY_NAME;
      h.STATE =  State.parse(json.STATE);
      h.STAGE = Stage.parse(json.STAGE);
      h.TYPE = json.TYPE;
      h.SYSTEM_TYPE = json.SYSTEM_TYPE;

      return h;
    } else return null;
  }

  static parseArray(json: any[]): ReportLink[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new ReportLink(j));

    return arr;
  }

  getDisplayName(): string {
    let reportType = "R";

    if(this.TYPE == LinkedReportType.ORDER)
      reportType = "O";
    else if(this.TYPE == LinkedReportType.QUOTE)
      reportType = "Q";

    return `(${reportType}) ${this.SYSTEM_TYPE} - ${this.COMPANY_NAME}`;
  }
}
